import React, { useState, useEffect } from "react";
import { DataStore } from "@aws-amplify/datastore";
import { Card } from "react-bootstrap";
import { VehicleModelGeneralInfo } from "../models";

function Suggestions({ suggestions, onSuggestionSelect }) {
    return (
        <div className="disappear card mx-auto d-flex flex-column justify-content-between">
            {suggestions.map((suggestion, index) => (
                <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => onSuggestionSelect(suggestion)}
                >
                    {suggestion.Manufacturer} {suggestion.ModelName}
                </div>
            ))}
        </div>
    );
}

export default function Planes() {
    const [planes, setPlanes] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedPlane, setSelectedPlane] = useState(null);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    useEffect(() => {
        const searchInput = document.querySelector(".search-input");
        const suggestionsList = document.querySelector(".disappear");

        function handleClickOutside(event) {
            if (searchInput && !searchInput.contains(event.target) && suggestionsList && !suggestionsList.contains(event.target)) {
                setFilteredSuggestions([]);
            }
        }

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchPlanes();
    }, []);

    async function fetchPlanes() {
        try {
            const fetchedPlanes = await DataStore.query(VehicleModelGeneralInfo);
            setPlanes(fetchedPlanes);
            console.log(fetchedPlanes);
        } catch (error) {
            console.error("Error fetching planes:", error);
        }
    }

    function filterPlanes(plane, searchQuery) {
        const words = searchQuery.toLowerCase().split(" ");
        return (
            plane.VehicleType === "PLANE" &&
            plane.Manufacturer &&
            plane.ModelName &&
            words.every(
                (word) =>
                    plane.Manufacturer.toLowerCase().includes(word) ||
                    plane.ModelName.toLowerCase().includes(word)
            )
        );
    }

    function handleInputChange(event) {
        const query = event.target.value;
        setSearchQuery(query);
        const suggestions = planes.filter((plane) => filterPlanes(plane, query));
        setFilteredSuggestions(suggestions);
    }

    function handleSuggestionSelect(suggestion) {
        setSelectedPlane(suggestion);
        setFilteredSuggestions([]); // Clear suggestions
    }

    function toggleSuggestions() {
        if (filteredSuggestions.length > 0) {
            setFilteredSuggestions([]);
        } else {
            const planesOnly = planes.filter(plane => plane.VehicleType === "PLANE");
            setFilteredSuggestions(planesOnly);
        }
    }

    return (
        <div style={{ position: "relative" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <input
                    className="search-input card mx-auto d-flex flex-column justify-content-between"
                    type="text"
                    placeholder="Click here to see planes or search plane models..."
                    value={searchQuery}
                    onChange={handleInputChange}
                    onClick={toggleSuggestions}
                    style={{ padding: "10px", marginBottom: "5px" }}
                />

                {filteredSuggestions.length > 0 && (
                    <Suggestions
                        suggestions={filteredSuggestions}
                        onSuggestionSelect={handleSuggestionSelect}
                    />
                )}
            </div>

            {selectedPlane && (
                <div className="homepageCarousel">
                    <Card className="card mx-auto d-flex flex-column justify-content-between">
                        <div>
                            <Card.Img
                                variant="top"
                                src={selectedPlane.Picture}
                                alt={`Slide plane`}
                            />
                            <Card.Body className="card-body"
                                style={{ maxHeight: "400px", overflowY: "auto" }}>
                                <Card.Text>Vehicle Type: {selectedPlane.VehicleType}</Card.Text>
                                <Card.Text>Aircraft Type: {selectedPlane.BodyStyle}</Card.Text>
                                <Card.Text>Engine Type: {selectedPlane.EngineCategory}</Card.Text>
                                <Card.Text>Engine Capacity: {selectedPlane.EngineSize_litres}</Card.Text>
                                <Card.Text>Wingspan (meters): {selectedPlane.Wingspan_meters}</Card.Text>
                                <Card.Text>General Dimensions (meters): {selectedPlane.GeneralDimensions_meters}</Card.Text>
                                <Card.Text>Maximum Takeoff Weight (kg): {selectedPlane.CurbWeight_kg}</Card.Text>
                                <Card.Text>Seating Capacity: {selectedPlane.SeatingCapacity}</Card.Text>
                                <Card.Text>Cruising Speed (km/h): {selectedPlane.TopSpeed_kmph}</Card.Text>
                                <Card.Text>Average Market Price (CAD): {selectedPlane.AverageMarketPrice_CAD}</Card.Text>
                                <Card.Text>Safety Rating: {selectedPlane.SafetyRating}</Card.Text>
                                <Card.Text>General Information: {selectedPlane.Information}</Card.Text>
                            </Card.Body>


                        </div>
                    </Card>
                </div>
            )}
        </div>
    );
}
